<template>
  <v-container fluid class="mt-4">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title>
            <span class="text-subtitle-1">
              Formato de requisición de paneles - Sistemas
            </span>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark small tile @click="abrirDialogoNueva">
              <v-icon left small>mdi-plus</v-icon>
              Nueva solicitud
            </v-btn>
            <v-btn color="green" dark small tile @click="exportarExcel(requisiciones, 'requisiciones_sistemas')" class="ml-2">
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
            <!-- actualizar -->
            <v-btn color="primary" dark small tile @click="initialize" class="ml-2">
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  v-model="search"
                  label="Buscar"
                  dense
                  rounded
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="requisiciones"
                :items-per-page="10"
                class="elevation-0"
                dense
              >
                <template v-slot:item.tipoSolicitud="{ item }">
                  {{ (item.tipoSolicitud || []).join(', ') }}
                </template>
                <template v-slot:item.prioridad="{ item }">
                  <!-- Agregar chips con colores -->
                  <v-chip small color="green" dark v-if="item.prioridad == 'Alta'">Alta</v-chip>
                  <v-chip small color="yellow" dark v-else-if="item.prioridad == 'Media'">Media</v-chip>
                  <v-chip small color="red" dark v-else>Baja</v-chip>
                </template>

                <template v-slot:item.estatus="{ item }">
                  <!-- Agregar chips con colores -->
                  <v-chip small color="green" dark v-if="item.estatus == 'Terminado'">Terminado</v-chip>
                  <v-chip small color="orange" dark v-else-if="item.estatus == 'En Proceso'">En Proceso</v-chip>
                  <v-chip small color="black" dark v-else-if="item.estatus == 'Cancelado'">Cancelado</v-chip>
                  <v-chip small color="red" dark v-else-if="item.estatus == 'Sin iniciar'">Sin iniciar</v-chip>
                  <v-chip small color="grey" dark v-else>Sin estatus</v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn icon small @click="editar(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <!-- Botón para eliminar -->
                  <v-btn 
                    icon 
                    small 
                    @click="eliminar(item)"
                    v-if="item.responsable == getdatosUsuarioERPERP.iderp || getdatosUsuarioERPERP.idpuesto == 11"
                  >
                    <v-icon small color="red">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <template v-slot:no-data>
                  <div class="text-center grey--text text--darken-1 py-4">
                  No hay solicitudes registradas.
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo de alta / edición -->
    <v-dialog v-model="dialog" max-width="1000px" scrollable persistent @keydown.ctrl="pegar">
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ editando ? 'Editar requisición' : 'Nueva requisición' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="formRequisicion">
            <!-- 1. DATOS GENERALES DE LA SOLICITUD -->
            <div class="text-subtitle-2 mb-2">1. Datos generales de la solicitud</div>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.fechaSolicitud"
                  label="Fecha de solicitud"
                  type="date"
                  dense
                  filled
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.nombre_responsable"
                  label="Nombre del responsable"
                  dense
                  filled
                  hide-details
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <!-- autocomplete de departamentos -->
                <v-autocomplete
                  v-model="form.departamento"
                  label="Departamento solicitante"
                  dense
                  :items="departamentos"
                  filled
                  hide-details
                  item-text="departamento"
                  item-value="iddepartamento"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.sistema"
                  label="Sistema / Plataforma involucrada"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- 2. TIPO DE SOLICITUD -->
            <div class="text-subtitle-2 mb-2">2. Tipo de solicitud</div>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Nuevo panel"
                  value="Nuevo panel"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Ajuste a panel existente"
                  value="Ajuste a panel existente"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Mejora visual / UX"
                  value="Mejora visual / UX"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Corrección de error"
                  value="Corrección de error"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Nueva funcionalidad"
                  value="Nueva funcionalidad"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Reporte / Métricas"
                  value="Reporte / Métricas"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.tipoSolicitud"
                  label="Otro"
                  value="Otro"
                  hide-details
                  dense
                ></v-checkbox>
                <v-text-field
                  v-model="form.tipoSolicitudOtro"
                  label="Especifique (si eligió 'Otro')"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- 3. DESCRIPCIÓN GENERAL -->
            <div class="text-subtitle-2 mb-2">
              3. Descripción general de la solicitud
            </div>
            <v-textarea
              v-model="form.descripcionGeneral"
              label="Describe qué necesitas, para qué lo necesitas y qué problema resuelve"
              filled
              rows="3"
              auto-grow
            ></v-textarea>

            <v-divider class="my-4"></v-divider>

            <!-- 4. DEFINICIÓN FUNCIONAL DEL PANEL -->
            <div class="text-subtitle-2 mb-2">
              4. Definición funcional del panel
            </div>
            <div class="font-weight-medium mb-1">4.1 ¿Qué información necesitas ver?</div>
            <v-textarea
              v-model="form.camposMetricas"
              label="Campos / métricas requeridas"
              filled
              rows="3"
              auto-grow
            ></v-textarea>

            <v-textarea
              v-model="form.origenInformacion"
              label="Origen de la información"
              filled
              rows="2"
              auto-grow
              class="mt-2"
            ></v-textarea>

            <div class="font-weight-medium mt-4 mb-1">
              4.2 ¿Qué tipo de visualización ocupas?
            </div>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Tabla"
                  value="Tabla"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Gráfica de barras"
                  value="Gráfica de barras"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Gráfica de líneas"
                  value="Gráfica de líneas"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Gráfica de pastel"
                  value="Gráfica de pastel"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Indicadores (KPIs / contadores)"
                  value="Indicadores (KPIs / contadores)"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Comparativos"
                  value="Comparativos"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="Dashboard mixto"
                  value="Dashboard mixto"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.tiposVisualizacion"
                  label="No aplica"
                  value="No aplica"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>

            <div class="font-weight-medium mt-4 mb-1">
              4.3 ¿Qué acciones debe permitir el panel?
            </div>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.accionesPanel"
                  label="Filtros por fecha"
                  value="Filtros por fecha"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.accionesPanel"
                  label="Filtros por usuario / sucursal / estatus"
                  value="Filtros por usuario / sucursal / estatus"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.accionesPanel"
                  label="Exportar (Excel / PDF)"
                  value="Exportar (Excel / PDF)"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.accionesPanel"
                  label="Detalle al dar clic"
                  value="Detalle al dar clic"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox
                  v-model="form.accionesPanel"
                  label="Edición de información"
                  value="Edición de información"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.accionesPanel"
                  label="Solo consulta"
                  value="Solo consulta"
                  hide-details
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>

            <div class="font-weight-medium mt-4 mb-1">
              4.4 ¿Qué resultado esperas obtener?
            </div>
            <v-textarea
              v-model="form.resultadoEsperado"
              label="Qué decisión o control buscas lograr"
              filled
              rows="2"
              auto-grow
            ></v-textarea>

            <div class="font-weight-medium mt-4 mb-1">
              4.5 ¿Cómo sabrás que el panel está bien hecho?
            </div>
            <v-textarea
              v-model="form.criterioExito"
              label="Criterio de éxito"
              filled
              rows="2"
              auto-grow
            ></v-textarea>

            <v-divider class="my-4"></v-divider>

            <!-- 5. USUARIOS QUE LO UTILIZARÁN -->
            <div class="text-subtitle-2 mb-2">
              5. Usuarios que lo utilizarán
            </div>
            <v-row dense>
              <v-col cols="12" md="6">
                <div class="font-weight-medium mb-1">Roles</div>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="Dirección"
                  value="Dirección"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="Coordinación"
                  value="Coordinación"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="Ventas"
                  value="Ventas"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="Académico"
                  value="Académico"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="Administración"
                  value="Administración"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="TI"
                  value="TI"
                  hide-details
                  dense
                ></v-checkbox>
                <v-checkbox
                  v-model="form.rolesUsuarios"
                  label="Otro"
                  value="Otro"
                  hide-details
                  dense
                ></v-checkbox>
                <v-text-field
                  v-model="form.rolOtro"
                  label="Otro rol (especifique)"
                  dense
                  filled
                  hide-details
                  class="mt-1"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.cantidadUsuarios"
                  label="Cantidad aproximada de usuarios"
                  type="number"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- 6. PRIORIDAD DE LA SOLICITUD -->
            <div class="text-subtitle-2 mb-2" v-if="[334,1,2230, 954].includes( getdatosUsuarioERPERP.iderp )">
              6. Prioridad de la solicitud (Sistemas / Dirección)
            </div>
            <v-row dense v-if="[334,1,2230, 954].includes( getdatosUsuarioERPERP.iderp )">
              <v-col cols="12" md="6">
                <v-radio-group v-model="form.prioridad" row hide-details>
                  <v-radio label="Baja (mejora deseable)" value="Baja"></v-radio>
                  <v-radio label="Media (impacta operación)" value="Media"></v-radio>
                  <v-radio label="Alta (bloquea proceso crítico)" value="Alta"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.justificacionPrioridad"
                  label="Justificación de la prioridad"
                  filled
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- 7. FECHA REQUERIDA -->
            <div class="text-subtitle-2 mb-2">7. Fecha requerida</div>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.fechaIdealEntrega"
                  label="Fecha ideal de entrega"
                  type="date"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.fechaLimite"
                  label="Fecha límite"
                  type="date"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- 8. REFERENCIAS O MATERIAL ADICIONAL -->
            <div class="text-subtitle-2 mb-2">
              8. Referencias o material adicional
            </div>
            <v-textarea
              v-model="form.referencias"
              label="Capturas, archivos, enlaces o descripción del material adicional"
              filled
              rows="3"
              auto-grow
            ></v-textarea>

            <!-- 9. Evidencias -->
            <div class="text-subtitle-2 mb-2 mt-4">
              9. Evidencias (capturas, videos, etc.)
            </div>

            <v-row>
              <v-col cols="12" >
                <v-file-input
                  small-chips
                  multiple
                  filled
                  v-model="files"
                  accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*"
                  placeholder="Selecciona tus archivos"
                  prepend-icon="mdi-camera"
                  label="Evidencias"
                  @change="cargarFotos"
                />
              </v-col>
            </v-row>

            <v-row v-if="vistaPrevias.length ">
              <v-col cols="12" md="3" v-for="(img, i) in vistaPrevias" :key="i">
                <v-card class="py-4 shadowCard">
                  <v-img
                    v-if="!img.video"
                    :src="img.url"
                    contain
                    aspect-ratio="2"
                  />
                  <video
                    v-else
                    :src="img.url"
                    style="width: 100%; height: 100%;"
                  ></video>
                  <v-btn
                    color="error"
                    small
                    @click="eliminarFoto(img.url)"
                    top
                    right
                    absolute
                    fab
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="form.evidencias.length">
              <v-col cols="12" md="3" v-for="(img, i) in form.evidencias" :key="i">
                <v-card class="py-4 shadowCard">
                  <video
                    v-if="img.match('mp4')"
                    :src="urlRuta +img"
                    style="width: 100%; height: 100%;"
                    @click="verVideo(img)"
                    controls
                  ></video>
                  <v-img
                  v-else
                    :src="urlRuta +img"
                    contain
                    aspect-ratio="2"
                    @click="verImagen(img)"
                  />
                  
                </v-card>
              </v-col>
            </v-row>

            

            <v-divider class="my-4"></v-divider>

            <!-- 10. USO EXCLUSIVO DE SISTEMAS -->
            <div class="text-subtitle-2 mb-2" v-if="[334,1,2230, 954].includes( getdatosUsuarioERPERP.iderp )">
              10. Uso exclusivo de Sistemas (Sistemas / Dirección)
            </div>
            <v-row dense v-if="[334,1,2230, 954].includes( getdatosUsuarioERPERP.iderp )">
              <v-col cols="12" md="6">
                <div class="font-weight-medium mb-1">Análisis técnico</div>
                <v-radio-group v-model="form.analisisTecnico" row hide-details>
                  <v-radio label="Viable" value="Viable"></v-radio>
                  <v-radio label="No viable" value="No viable"></v-radio>
                  <v-radio label="Requiere ajuste" value="Requiere ajuste"></v-radio>
                </v-radio-group>

                <div class="font-weight-medium mt-3 mb-1">Nivel de complejidad</div>
                <v-radio-group v-model="form.complejidad" row hide-details>
                  <v-radio label="Bajo" value="Bajo"></v-radio>
                  <v-radio label="Medio" value="Medio"></v-radio>
                  <v-radio label="Alto" value="Alto"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.tiempoEstimado"
                  label="Tiempo estimado"
                  dense
                  filled
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="form.desarrolladorAsignado"
                  label="Desarrollador asignado"
                  dense
                  filled
                  hide-details
                  class="mt-2"
                ></v-text-field>
                <v-text-field
                  v-model="form.fechaEstimadaEntrega"
                  label="Fecha estimada de entrega"
                  type="date"
                  dense
                  filled
                  hide-details
                  class="mt-2"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- 11. APROBACIONES -->
            <div class="text-subtitle-2 mb-2">11. Aprobaciones</div>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.solicitante"
                  label="Solicitante"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.jefeSistemas"
                  label="Jefe de Sistemas"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- 11. APROBACIONES -->
            <div class="text-subtitle-2 mb-2">11. Estatus</div>
            <v-row dense>
              <v-col cols="12" md="6">
                <div class="font-weight-medium mb-1">Estatus</div>
                <v-radio-group v-model="form.estatus" row hide-details>
                  <v-radio label="Terminado"   value="Terminado"></v-radio>
                  <v-radio label="En Proceso"  value="En Proceso"></v-radio>
                  <v-radio label="Cancelado"   value="Cancelado"></v-radio>
                  <v-radio label="Sin iniciar" value="Sin iniciar"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogo">Cancelar</v-btn>
          <v-btn color="primary" @click="guardar">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVideo" max-width="1000px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogVideo = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
      </v-card>
      <v-card-text>
        <video :src="urlRuta + video" controls></video>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialogVideo = false">Cerrar</v-btn>
      </v-card-actions>
    </v-dialog>

    <v-dialog v-model="dialogImagen" max-width="1000px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogImagen = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-img :src="urlRuta + imagen" contain></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogImagen = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEliminar" max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogEliminar = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la requisición?
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogEliminar = false">Cerrar</v-btn>
          <v-btn color="error" @click="eliminarRequisicion">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Clipboard } from "@capacitor/clipboard";
  import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

export default {

  mixins: [ validarErrores, funcionesExcel ],

  components:{
    Alerta,
    carga,
  },

  data: () => ({
    // Alertas
    parametros:{
      dialogError: false,
      mensaje: '',
      color: ''
    },
    dialog: false,
    editando: false,
    requisiciones: [],
    headers: [
      { text: 'Fecha solicitud', value: 'fecha_solicitud' },
      { text: 'Departamento', value: 'departamento_nombre' },
      { text: 'Responsable', value: 'nombre_responsable' },
      { text: 'Sistema', value: 'sistema' },
      { text: 'Tipo solicitud', value: 'tipo_solicitud' },
      { text: 'Prioridad', value: 'prioridad' },
      { text: 'Fecha ideal', value: 'fecha_ideal_entrega' },
      { text: 'Fecha entrega', value: 'fecha_estimada_entrega' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    departamentos: [
      { iddepartamento: 1, departamento: 'Sistemas' },
      { iddepartamento: 2, departamento: 'Dirección' },
      { iddepartamento: 3, departamento: 'Ventas' },
      { iddepartamento: 4, departamento: 'Académico' },
      { iddepartamento: 5, departamento: 'Administración' },
      { iddepartamento: 6, departamento: 'TI' },
      { iddepartamento: 7, departamento: 'Otro' }
    ],

    search:'',
    form: null,
    files: [],
    vistaPrevias: [],
    urlRuta:'',
    dialogVideo: false,
    dialogImagen: false,
    video: '',
    imagen: '',
    dialogEliminar: false,
    readonly: false
  }),

  computed:{
      ...mapGetters('login',['getdatosUsuarioERPERP']),
  },

  created() {
    this.form = this.nuevaRequisicion()
    this.urlRuta = axios.defaults.baseURL + 'evidencia-sistemas/'

    this.initialize()
  },
  methods: {

    initialize() {
      this.cargar = true
      this.requisiciones = []
      this.$http.get('requisiciones.ti').then(response=>{
        this.requisiciones = response.data

        for(let i = 0; i < this.requisiciones.length; i++){
          this.requisiciones[i].departamento_nombre = this.departamentos.find(el => el.iddepartamento == this.requisiciones[i].departamento).departamento
        }
      }).catch(error=>{
        this.validarError(error.response.data.message)
      }).finally(()=>{
        this.cargar = false
      })
    },

    nuevaRequisicion() {
      const hoy = new Date().toISOString().slice(0, 10)
      return {
        id: null,
        fechaSolicitud: hoy,
        departamento: '',
        responsable: this.getdatosUsuarioERPERP.iderp,
        sistema: '',
        tipoSolicitud: [],
        tipoSolicitudOtro: '',
        descripcionGeneral: '',
        camposMetricas: '',
        origenInformacion: '',
        tiposVisualizacion: [],
        accionesPanel: [],
        resultadoEsperado: '',
        criterioExito: '',
        rolesUsuarios: [],
        rolOtro: '',
        cantidadUsuarios: '',
        prioridad: '',
        justificacionPrioridad: '',
        fechaIdealEntrega: '',
        fechaLimite: '',
        referencias: '',
        analisisTecnico: '',
        complejidad: '',
        tiempoEstimado: '',
        desarrolladorAsignado: '',
        fechaEstimadaEntrega: null,
        solicitante: '',
        jefeSistemas: '',
        departamento: null,
        evidencias: [],
        estatus: null,
      }
    },
    abrirDialogoNueva() {
      this.editando = false
      this.form = this.nuevaRequisicion()
      this.dialog = true
    },
    editar(item) {
      console.log( item )
      this.editando = true

      this.readonly = this.getdatosUsuarioERPERP.iderp == item.responsable || this.getdatosUsuarioERPERP.idpuesto == 11 ? true : false

      this.form = {
        id: item.id,
        fechaSolicitud: item.fecha_solicitud,
        departamento: item.departamento,
        responsable: item.responsable,
        nombre_responsable: item.nombre_responsable,
        sistema: item.sistema,
        tipoSolicitud: Array.isArray(item.tipo_solicitud) ? [...item.tipo_solicitud] : [],
        tipoSolicitudOtro: item.tipo_solicitud_otro,
        descripcionGeneral: item.descripcion_general,
        camposMetricas: item.campos_metricas,
        origenInformacion: item.origen_informacion,
        tiposVisualizacion: Array.isArray(item.tipos_visualizacion) ? [...item.tipos_visualizacion] : [],
        accionesPanel: Array.isArray(item.acciones_panel) ? [...item.acciones_panel] : [],
        evidencias: Array.isArray(item.evidencias) ? [...item.evidencias] : [],
        resultadoEsperado: item.resultado_esperado,
        criterioExito: item.criterio_exito,
        rolesUsuarios: Array.isArray(item.roles_usuarios) ? [...item.roles_usuarios] : [],
        rolOtro: item.rol_otro,
        cantidadUsuarios: item.cantidad_usuarios,
        prioridad: item.prioridad,
        justificacionPrioridad: item.justificacion_prioridad,
        fechaIdealEntrega: item.fecha_ideal_entrega,
        fechaLimite: item.fecha_limite,
        referencias: item.referencias,
        analisisTecnico: item.analisis_tecnico,
        complejidad: item.complejidad,
        tiempoEstimado: item.tiempo_estimado,
        desarrolladorAsignado: item.desarrollador_asignado,
        fechaEstimadaEntrega: item.fecha_estimada_entrega,
        solicitante: item.solicitante,
        jefeSistemas: item.jefe_sistemas,
        estatus: item.estatus,
      }
      this.dialog = true
    },
    cerrarDialogo() {
      this.dialog = false
    },
    async guardar() {
      if (!this.form.departamento || !this.form.responsable || !this.form.sistema) {
        // Validaciones simples mínimas
        this.validarErrorDirecto('Favor de llenar todos los campos obligatorios')
        return
      }

      if( this.vistaPrevias.length ){
        const response = await this.subirFotosServidor()
        this.form.evidencias = this.form.evidencias.concat( response.data )
      }


      if (this.editando && this.form.id != null) {
        this.$http.put('requisiciones.ti.update/' + this.form.id, this.form).then(response=>{
          this.validarSuccess(response.data.message)
          this.initialize()
          this.cerrarDialogo()
        }).catch(error=>{
          this.validarError(error.response.data.message)
        })
      } else {
        const nuevo = { ...this.form }
        nuevo.id = Date.now()

        // Mandamos a guardar primero las imagenes
        // this.requisiciones.push(nuevo)
        // guardar en la base de datos
        this.$http.post('requisiciones.ti.add', nuevo).then(response=>{
          this.validarSuccess(response.data.message)
          this.initialize()
          this.cerrarDialogo()
        }).catch(error=>{
          this.validarError(error.response.data.message)
        })
      }
    },

    eliminar( item ) {
      this.form = item
      this.dialogEliminar = true
    },

    eliminarRequisicion() {
      this.$http.put('requisiciones.ti.delete/' + this.form.id, { deleted: 1 }).then(response=>{
        this.validarSuccess(response.data.message)
        this.initialize()
        this.dialogEliminar = false
        this.cerrarDialogo()
      }).catch(error=>{
        this.validarError(error.response.data.message)
      })
    },

    subirFotosServidor() {
      let formData = new FormData();

      for (const i in this.vistaPrevias) {
        formData.append('file', this.vistaPrevias[i].file);
      }

      return this.$http.post('requisiciones.ti.evidencia', formData);


    },

    cargarFotos(){
      if(this.files.length < 1){
        return
      }

      this.files.forEach((element, index) => {
        let formData = new FormData();
        formData.append('file', element);
        if(element.size > 26214400){ // 25MB
          this.validarErrorDirecto('El archivo sobrepasa el limite del peso, max 25 MB')
        } else {
          this.getBase64(element, formData)
        }
      })
    },

    getBase64(file, formData) {
      var me = this
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        var video = false
        const nombreSplit = file.name.split('.')
        const extension = nombreSplit[nombreSplit.length-1]
        if(['mp4', 'mov', 'wmv', 'avi'].includes(extension)){
          video = true
        }
        me.vistaPrevias.push({
          url: reader.result, 
          formData: formData, 
          image_name: file.name,
          video : video,
          file
        })
      };
    },

    eliminarFoto(value){
      this.vistaPrevias.forEach((element, index)=>{
        if(element.url == value){
          this.vistaPrevias.splice(index,1);
        }
      })
    },

    async pegar(event) {
      if (event.code == "KeyV") {
        const { type, value } = await Clipboard.read();

                  // Validamos que sea de tipo imagen
        if (type == "image/png") {
                  // Convertimos el base64 en una imagen
          const file = this.convertFile(value, "imagen.png");
          this.createFile(file);
        }
      }
    },

    convertFile(dataurl, filename) {
      var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    createFile(file) {
      if (file.size > 10000000) {
        alert("please check file size no over 5 MB.");
        this.dragging = false;
        return;
      }

      this.file = file;
      this.archivos = file;
      this.getBase64(this.archivos);
      this.dragging = false;
    },

    verVideo(img) {
      this.video = img
      this.dialogVideo = true
    },
    verImagen(img) {
      this.imagen = img
      this.dialogImagen = true
    },
  }
}
</script>

<style scoped>
  .shadowCard {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
</style>

